// components/Dashboard/CompletionGauge.jsx - Radial gauge for completion rate
import React from 'react';
import { RadialBarChart, RadialBar, ResponsiveContainer, PolarAngleAxis } from 'recharts';

export default function CompletionGauge({ value, loading }) {
  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow p-6 animate-pulse">
        <div className="h-6 bg-gray-200 rounded w-32 mb-4"></div>
        <div className="h-48 flex items-center justify-center">
          <div className="w-32 h-32 rounded-full bg-gray-200"></div>
        </div>
      </div>
    );
  }

  const percentage = Math.round(value || 0);

  const data = [
    {
      name: 'Completion',
      value: percentage,
      fill: percentage >= 75 ? '#059669' : percentage >= 50 ? '#F59E0B' : '#EF4444'
    }
  ];

  const getStatusText = () => {
    if (percentage >= 75) return 'Excellent';
    if (percentage >= 50) return 'Good';
    if (percentage >= 25) return 'Fair';
    return 'Needs Attention';
  };

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-medium text-gray-900 mb-2">Completion Rate</h3>
      <div className="h-48 relative">
        <ResponsiveContainer width="100%" height="100%">
          <RadialBarChart
            cx="50%"
            cy="50%"
            innerRadius="60%"
            outerRadius="100%"
            barSize={20}
            data={data}
            startAngle={180}
            endAngle={0}
          >
            <PolarAngleAxis
              type="number"
              domain={[0, 100]}
              angleAxisId={0}
              tick={false}
            />
            <RadialBar
              background={{ fill: '#E5E7EB' }}
              dataKey="value"
              cornerRadius={10}
              angleAxisId={0}
            />
          </RadialBarChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 flex flex-col items-center justify-center" style={{ marginTop: '20px' }}>
          <span className="text-4xl font-bold text-gray-900">{percentage}%</span>
          <span className="text-sm text-gray-500 mt-1">{getStatusText()}</span>
        </div>
      </div>
      <p className="text-center text-sm text-gray-500 mt-2">
        Forms completed vs. sent
      </p>
    </div>
  );
}
